import { Skeleton } from "@/components/ui/skeleton"; // adjust import path as needed

const MetricCardSkeleton = () => (
  <div className="border border-gray-100 rounded-sm p-4 flex flex-col gap-3">
    <div className="flex items-center justify-between">
      <Skeleton className="h-4 w-40" />
      <Skeleton className="h-5 w-14 rounded-full" />
    </div>
    <Skeleton className="h-3 w-full" />
    <Skeleton className="h-3 w-4/5" />
    <div className="flex items-center gap-2 mt-1">
      {[...Array(5)].map((_, i) => (
        <Skeleton key={i} className="h-6 w-6 rounded-sm" />
      ))}
    </div>
    <Skeleton className="h-3 w-3/4 mt-1" />
  </div>
);

export const PerformanceIndividualReviewSkeleton = () => {
  return (
    <section className="flex flex-col gap-4 bg-white p-4 rounded-sm">
      {/* Top bar */}
      <div className="flex items-center gap-3">
        <Skeleton className="h-9 w-9 rounded-xs shrink-0" />
        <Skeleton className="h-5 w-52" />
      </div>

      <div className="flex flex-col h-full border rounded-sm overflow-hidden">
        <div className="flex flex-1 gap-0 overflow-hidden">
          {/* Left panel */}
          <div className="flex flex-col flex-1">
            {/* Header */}
            <div className="flex items-center gap-4 p-5 border-b border-gray-100">
              <Skeleton className="h-12 w-12 rounded-full shrink-0" />
              <div className="flex flex-col gap-2 flex-1">
                <Skeleton className="h-4 w-36" />
                <Skeleton className="h-3 w-24" />
              </div>
              <div className="flex flex-col gap-2 items-end">
                <Skeleton className="h-3 w-20" />
                <Skeleton className="h-3 w-28" />
              </div>
            </div>

            {/* Metric cards */}
            <div className="flex-1 p-5 flex flex-col gap-4">
              {[...Array(3)].map((_, i) => (
                <MetricCardSkeleton key={i} />
              ))}
            </div>
          </div>

          {/* Right panel — ResultSummary */}
          <div className="w-72 shrink-0 border-s border-border p-5 flex flex-col gap-5">
            <Skeleton className="h-4 w-32" />
            <div className="flex justify-center">
              <Skeleton className="h-24 w-24 rounded-full" />
            </div>
            <div className="flex flex-col gap-3 mt-2">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="flex flex-col gap-1.5">
                  <div className="flex justify-between">
                    <Skeleton className="h-3 w-24" />
                    <Skeleton className="h-3 w-8" />
                  </div>
                  <Skeleton className="h-1.5 w-full rounded-full" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
